import { Injectable } from '@angular/core';

declare const bootstrap: any; // 👈 importa bootstrap.js globalmente

@Injectable({ providedIn: 'root' })
export class TooltipInitService {
  constructor() {
    this.inicializarTooltips();
  }

  inicializarTooltips(): void {
    const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.forEach((el) => {
      new bootstrap.Tooltip(el);
    });
  }
}
